import { create } from 'zustand'
import { kvGet, kvSet } from './db'

export type MotionChoice = 'auto' | 'calm' | 'still'

export interface Settings {
  glove: boolean
  sound: boolean
  vibration: boolean
  motion: MotionChoice
  /** Organiser only: shows editing tools and the World panel. */
  organiserTools: boolean
}

const DEFAULTS: Settings = { glove: false, sound: true, vibration: true, motion: 'auto', organiserTools: true }

interface SettingsState extends Settings {
  restore(): Promise<void>
  set<K extends keyof Settings>(key: K, value: Settings[K]): void
}

export const useSettings = create<SettingsState>((set, get) => ({
  ...DEFAULTS,
  async restore() {
    set({ ...DEFAULTS, ...((await kvGet<Partial<Settings>>('settings')) ?? {}) })
  },
  set(key, value) {
    set({ [key]: value } as Partial<Settings>)
    const { glove, sound, vibration, motion, organiserTools } = get()
    void kvSet('settings', { glove, sound, vibration, motion, organiserTools })
  },
}))
